import React from 'react';
import GameStateImpl from './gameState';
import { IGameProvider, IGameService, ITableRepository } from '@base/features/game/model/interfaces';
import GameBoardPage from '../components/gameboardPage/gameBoardPage';
import { MessagesService } from '@base/features/chat/messagesService';
import { IPreferencesService } from '@base/features/preferences/model/types';
import { IModalProvider } from '@base/features/modal/model/interfaces';
import { IPlayersOnlineRepository } from '@base/features/player/model/interfaces';
import { Preferences } from '@backgammon/constants/defaultPreferences';
import { ReactComponent as TableIcon } from '@base/assets/images/table.svg';
import BoardSelector from '@backgammon/components/preferences/boardSelector';
import Table from './table';
import SoundProvider from '@base/features/game/model/soundProvider';
import LobbyService from '@base/features/lobby/model/lobbyService';
import { ISocketClient } from '@base/features/socket/interfaces';
import Codes from '@base/features/socket/codes';
import {CreateTableSettings} from '@base/features/table/interfaces';
import HelpPage from '../components/help/components/HelpPage';

export default class GameProvider implements IGameProvider<Preferences, Table> {
  GAME_ID = 5;
  APP_ID = 'dominos';
  APP_NAME = 'dominos';
  LOGO_URL = 'images/backgammon_logo.png';
  locales = ['en', 'de'];
  DEFAULT_TABLE_SETTINGS: CreateTableSettings = {
    // Так как в слайдере выбора оплаты самое маленькое значение это 1/2, то все
    // значения умножаются на 2, чтобы не отсылать на сервер дробные числа,
    // поэтому 10 это 5 тикетов
    cost: 10, 
    ratingGame: false,
    ladder: false,
    inviteOnly: false, 
    minPoints: 0, 
    noWatchers: false,
    timePerMove: 30, 
    maxPoints: -1, 
    gameColor: 0, 
    signs: 
      Codes.TableFlags.SPIN |
      Codes.TableFlags.DBL1 |
      Codes.TableFlags.DISCARD |
      Codes.TableFlags.SANDBAG |
      Codes.TableFlags.FROZ |
      Codes.TableFlags.LOSDEAL,
    timeGame: 5,
    timeGameAdd: 0,
    withTime: false,
    withTimePerMove: true, 
    reserved: 0, 
    jsonOptions: [],

    //Настройки стола для турнирной игры
    //Не нужно слать на сервер
    tourneyDefaultTableOptions: {
      tid: '',
      cost: 0,
    },
  };

  createGameState(
    table: Table,
    tablesRepository: ITableRepository,
    playersOnlineRepository: IPlayersOnlineRepository,
    lobbyService: LobbyService,
    soundProvider: SoundProvider<Preferences>,
    preferencesService: IPreferencesService<Preferences>,
    messagesService: MessagesService<Preferences, Table>,
    modalProvider: IModalProvider,
    gameService: IGameService,
    socket: ISocketClient,
  ) {
    return new GameStateImpl(
      table,
      tablesRepository,
      playersOnlineRepository,
      lobbyService,
      soundProvider,
      preferencesService,
      messagesService,
      modalProvider,
      gameService,
      socket
    );
  }

  getGameBoardView() {
    return <GameBoardPage />;
  }

  getGamePreferences() {
    return [
      { title: 'auto_roll', key: 'AUTO_ROLL' },
      { title: 'auto_confirm', key: 'AUTO_CONFIRM' },
      { title: 'my_home_is_on_left', key: 'MY_HOME_IS_ON_LEFT' },
    ]
  }

  getAdditionalPreferences() {
    return [
      {
        title: 'board',
        icon: <TableIcon />,
        content: <BoardSelector />,
      },
    ];
  }

  parseTournamentSettings(settings: [string, string, string]): [number, number, number] {
    const maxPoints = Number(settings[0]);
    const timePerMove = Number(settings[1]);
    const minPoints = Number(settings[2]);
    return [maxPoints, timePerMove, minPoints];
  }

  getHelpPage() {
    return <HelpPage/>
  }
}
